<template>
  <div class="wallpaper">
    <div class="headerLog">
      <a href="https://www.fhb.com/"
        ><img
          class="header-logo"
          srcset="@/assets/images/FHB-color-logo.png 1x, @/assets/images/FHB-color-logo2.png 2x"
          src="@/assets/images/FHB-color-logo2.png"
          alt="First Hawaiian Bank home logo"
          title="FHB home"
      /></a>
    </div>
    <div class="content" id="something-went-wrong">
      <div class="support-logo">
        <img
          class="support-logo"
          srcset="@/assets/images/MaintenanceLogo1.png 1x @/assets/images/MaintenanceLogo2.png 2x"
          src="@/assets/images/MaintenanceLogo2.png"
          alt="FHB Maintenance Logo"
        />
      </div>
      <div class="content-title">
        <h1>The application is currently down for maintenance.</h1>
      </div>
      <div class="content-text">
        <p class="content-text-p">Please try again later.</p>
      </div>
      <!-- 
      <div class="button-container">
        <a :href="process.env.VUE_APP_FHB_ONLINE_URL"><button class="submitBtn" type="submit" id="exit-something-went-wrong-btn" data-test="something-wrong-exit-btn">CLOSE</button></a>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "maintenance-page",
  methods: {},
}
</script>

<style scoped>
.wallpaper {
  background-image: url("~@/assets/images/orange@2x.svg");
  min-height: 100vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  /* justify-content: center; */
  align-items: center;
  flex-direction: column;
  background-color: #fef5ee;
  padding-top: 60px;
}

.content {
  width: max(529px, 40%);
  padding: 20px 30px 40px 30px;
  margin: 60px 0;
  background: rgba(255, 255, 255, 0.8);
}

.resend-code {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 40px;
  font-size: 18px;
  font-weight: 450;
}

.resend-code-btn {
  border: none;
  background-color: #ffffff;
  font-size: 18px;
  font-weight: 450;
  text-decoration: underline;
}

.button-container {
  text-align: center;
}

.submitBtn {
  height: 55px;
  width: 160px;
  position: relative;
  background-color: #fec443;
  border: 1px solid white;
  color: #444444;
  cursor: pointer;
  letter-spacing: 0.029em;
  border-radius: 30px;
  margin-top: 55px;
  /* margin-bottom: 40px; */
  display: inline-block;
  /* font-family: "CircularXX TT"; */
  font-weight: 700;
  line-height: 24px;
  align-items: center;
  text-align: center;
  font-feature-settings: "cpsp" on;
}

button:hover,
button:active {
  background-color: #fed67b;
  border-color: white;
}

.headerLog {
  text-align: center;
  /* margin-top: 36px; */
}

.support-logo {
  text-align: center;
  margin-top: 30px;
}

.support-logo img {
  height: auto;
  width: 100px;
}

.content-title {
  text-align: center;
  font-size: 28px;
  line-height: 42px;
  letter-spacing: -1.1%;
  font-weight: 700;
}

.content-text {
  text-align: center;
  font-size: 18px;
  font-weight: 450;
  margin-bottom: 5px;
}

.content-text-p {
  margin-top: 25px;
  margin-bottom: 40px;
  font-weight: 450;
  font-size: 18px;
  letter-spacing: -1.1%;
}

.send-code {
  margin-top: 40px;
  text-align: center;
  font-size: 18px;
  justify-content: center;
}
</style>
